exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".get-started-link[data-v-696922fc]{-webkit-box-align:center;-ms-flex-align:center;align-items:center}.get-started-chevron[data-v-696922fc],.get-started-link[data-v-696922fc]{display:-webkit-box;display:-ms-flexbox;display:flex}.get-started-chevron[data-v-696922fc]{-ms-flex-item-align:center;align-self:center}", ""]);

// exports
